/**
 * Textos da atualização automática da aba Meus Estudos (Flux Personalizado, #2004): a idade do
 * indicador e os avisos de estudo pronto.
 */

const SECONDS_PER_MINUTE = 60;
const MINUTES_PER_HOUR = 60;

/**
 * Avisos individuais de pronto por lote (um ciclo do polling). Os outros do mesmo lote viram um
 * aviso só, de resumo: com até 50 linhas por página, um aviso de 3,8 s por estudo prenderia a
 * fila por minutos.
 */
export const READY_NOTICES_PER_BATCH = 3;

/**
 * Idade do indicador em s → min → h (D18): "há 45 s", "há 3 min", "há 2 h". Arredonda para baixo
 * e nunca fica negativa (a resposta pode chegar entre dois tiques do relógio).
 *
 * @param ageMs - Agora menos a hora da última atualização, em ms.
 * @returns O trecho "há N <unidade>".
 */
export function formatUpdatedAge(ageMs: number): string {
  const seconds = Math.max(0, Math.floor(ageMs / 1000));
  if (seconds < SECONDS_PER_MINUTE) return `há ${seconds} s`;
  const minutes = Math.floor(seconds / SECONDS_PER_MINUTE);
  if (minutes < MINUTES_PER_HOUR) return `há ${minutes} min`;
  return `há ${Math.floor(minutes / MINUTES_PER_HOUR)} h`;
}

/**
 * Avisos de um lote de estudos prontos (`.dc.html:610`): "<NOME> está pronto para download." para
 * os {@link READY_NOTICES_PER_BATCH} primeiros e, se houver mais, um resumo ("E mais 2 estudos
 * estão prontos para download.").
 *
 * @param names - Nomes dos estudos que ficaram prontos no mesmo ciclo, na ordem da página.
 * @returns Os textos, na ordem em que entram na fila.
 */
export function readyNoticeMessages(names: readonly string[]): string[] {
  const shown = names.slice(0, READY_NOTICES_PER_BATCH)
    .map((name) => `${name} está pronto para download.`);
  const rest = names.length - shown.length;
  if (rest === 0) return shown;
  const summary = rest === 1
    ? 'E mais 1 estudo está pronto para download.'
    : `E mais ${rest} estudos estão prontos para download.`;
  return [...shown, summary];
}
